import React, {useState, useCallback, useEffect} from 'react';
import StepData from 'pattern/StepData.js';
import { connect } from "react-redux";
import SampleThumb from './SampleThumb.js';
import Colors from 'components/Colors.js';
import {setSampleDragging} from "actions/index.js";
import {ALTERNATE} from 'constants/instrument-mix-modes.js';
const colors = new Colors();

function Note(props) {
    const [samplers, setSamplers] =  useState([]);
    let className = "key";
    if (props.note.isBlackNote()) {
        className += " black";
    } else {
        className += " white";
    }

    let transpose = props.note.getTranspose();
    let samples = samplers.map(x => x.sample);

    const onDrop = useCallback((e) => {
        e.stopPropagation();
        if (props.sampleDragging) {
            props.instrument.newSample(transpose, props.sampleDragging)
                .then((s) => {
                    setSamplers(s.samplers);
                });
            props.setSampleDragging(undefined);
        }
    }, [props.sampleDragging, setSamplers]);

    const onClickSampler = useCallback((clickedSampler) => {
        if (clickedSampler === undefined) {
            let foundSampler = samplers.find(x => x.on);
            props.onClickSampler(foundSampler);
        } else if (clickedSampler !== props.selectedSampler) { 
            props.onClickSampler(clickedSampler);
            props.instrument.selectSampler(transpose, clickedSampler);
        }
    }, [transpose, samplers, props.onClickSampler, props.selectedSampler, props.mixMode]);

    useEffect(() => {
        if (transpose in props.instrument.samplers) {
            let _samplers = props.instrument.samplers[transpose];
            setSamplers(_samplers);
        }
    }, [props.instrument.samplers[transpose]], props.selectedSampler);

    const onMouseDown = useCallback(() => {
        console.log('transpose =', transpose);
        let track = props.instrument.track;
        let stepData = new StepData();
        stepData.copyFrom(track.trackData);
        stepData.transpose = transpose;
        stepData.slice = 0;
        stepData.duration = null;
        track.midiEffects.liveInputTrigger(stepData);
    }, [transpose]);

    const onMouseUp = useCallback(() => {
        props.instrument.track.midiEffects.liveInputRelease(
            transpose,
            0);
    }, [transpose]);


    let fullClassName = "key-container";
    if (samplers.indexOf(props.selectedSampler) > -1 && props.selectedSampler !== undefined) {
        fullClassName += " selected";
    }

    if (props.isPlaying) {
        fullClassName += ' last-played';
    }
    return (
        <div
          className={fullClassName}>
          <div
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
            onClick={() => onClickSampler()}
            onDrop={onDrop}
            className={className}/>
          {samplers.map(
                (sampler, i) => 
                  <SampleThumb
                        i={i}
                        key={'sample-thumb-' + i}
                        isSelectedSampler={sampler === props.selectedSampler}
                        sampler={sampler}
                        instrument={props.instrument}
                        onClickSampler={() => onClickSampler(sampler)}
                        sample={sampler.sample}/>
          )}
        </div>
    );
}
const mapDispatchToProps = (dispatch, props) => {
    return {
        setSampleDragging: (sample) => dispatch(setSampleDragging(sample)),
    };
};
 
const mapStateToProps = (state, props) => {
    return {
        isPlaying: state.keyboard.lastNotePlayed === props.transpose,
        mixMode: props.instrument.mixMode,
    }
};
 
export default connect(mapStateToProps, mapDispatchToProps)(Note);



